import React from 'react'

import { BASE_URL, ICONS } from '../../constants'

import { useIncident } from '../hooks'
import { useCrimeCategory } from '../../crimeCategories/hooks'

import IncidentDate from './IncidentDate'

import styles from './IncidentListItem.module.css'

const IncidentListItem = ({ incidentId }) => {
  const [
    {
      incidentDate,
      incidentTypeDescription,
      location,
      crimeCategory,
      actionableIntelligence
    },
    { select, onHover, onHoverEnd }
  ] = useIncident(incidentId)

  const category = useCrimeCategory(crimeCategory)

  return (
    <li
      className={styles.item}
      onClick={select}
      onMouseEnter={onHover}
      onMouseLeave={onHoverEnd}
    >
      <img
        className={styles.icon}
        alt={category.name}
        src={BASE_URL + ICONS.BORDERLESS.DIR + category.icon}
      />
      <div className={styles.title}>{incidentTypeDescription}</div>
      <div className={styles.street}>{location}</div>
      <IncidentDate style={styles.timestamp} date={incidentDate} />
      {actionableIntelligence && actionableIntelligence.length > 0 && (
        <span className={styles.aiCount}>{actionableIntelligence.length}</span>
      )}
    </li>
  )
}
export default IncidentListItem
